import { Button, ButtonProps, Popconfirm, Tooltip } from 'antd';
import { ForwardChatIcon } from 'assets';
import { useTransferChatSession, useProfile } from 'hooks';
import { messages, omniChatMessages } from 'messages';
import React, { useState } from 'react';
import { PERMISSION } from 'utils';
import { checkSomePermissions } from 'utils/check-permission';
import OmniChatSessionAssignModal from './OmniChatSessionAssignModal';
import { ChatSessionDto } from 'types';

interface AssignChatButtonProps extends ButtonProps {
  onSuccess?: () => void;
  onError?: (error: any) => void;
  chatSession: ChatSessionDto;
}

const AssignChatButton: React.FC<AssignChatButtonProps> = ({
  onSuccess,
  onError,
  children,
  chatSession,
  ...buttonProps
}) => {
  const { userPermissionIds } = useProfile();
  const { onTransferChatSession } = useTransferChatSession();
  const isLead = checkSomePermissions(userPermissionIds, [PERMISSION.ASSIGN_CHAT_CUSTOMER]);
  const [openModal, setOpenModal] = useState(false);

  const onConfirm = () => {
    if (chatSession) {
      onTransferChatSession(chatSession.chatSessionId).then(() => {
        afterAssign();
      });
    }
    onSuccess?.();
  };
  const afterAssign = () => {
    onSuccess?.();
  };

  const openModalSelectDTV = () => {
    setOpenModal(true);
  };
  const closeModalSelectDTV = () => {
    setOpenModal(false);
  };

  return (
    <>
      {isLead ? (
        <>
          <Tooltip trigger={'hover'} title={omniChatMessages.reAssign}>
            <Button
              onClick={openModalSelectDTV}
              type='text'
              className='h-8 w-8'
              shape='circle'
              icon={<ForwardChatIcon />}
            ></Button>
          </Tooltip>

          <OmniChatSessionAssignModal
            open={openModal}
            afterAssign={afterAssign}
            chatSession={chatSession}
            onCancel={closeModalSelectDTV}
            onClose={closeModalSelectDTV}
          />
        </>
      ) : (
        <>
          <Popconfirm
            title={omniChatMessages.forwardShiftLeader}
            description={omniChatMessages.confirmForwardShiftLeader}
            onConfirm={onConfirm}
            okText={messages.confirmButtonText}
            cancelText={messages.cancelButtonText}
            placement='topRight'
          >
            <Tooltip trigger={'hover'} title={omniChatMessages.forwardShiftLeader}>
              <Button
                onClick={openModalSelectDTV}
                type='text'
                className='h-8 w-8'
                shape='circle'
                icon={<ForwardChatIcon />}
              ></Button>
            </Tooltip>
          </Popconfirm>
        </>
      )}
    </>
  );
};

export default AssignChatButton;
